export const bizcrunchAppLiveUrl = "app.bizcrunch.co";
export const bizCrunchSiteUrl = "https://www.bizcrunch.co";
export const bizCrunchPolicyUrl = "https://www.bizcrunch.co/policies/";
export const bizCrunchchArticleUrl =
  "https://bizcrunch.tawk.help/article/how-do-bizcrunch-credits-work";
export const fundMyDealUrl = "https://bizcrunch.swoopfunding.com";
export const mixpanelApiHost = "https://api-eu.mixpanel.com";

export const lottieAnimationUrl =
  "https://lottie.host/998ea8e9-6e3b-43b9-8fe1-0bd824113069/xWUkOHakRC.json";
export const vimeoBiz4BizUrl = "https://vimeo.com/1022565834?share=copy";
export const youtubeUrl = "https://www.youtube.com/watch?v=OZPI9S0-oNE";
export const vimeoUrl = "https://vimeo.com/1054539120/fc51c8a404";
export const googleWorkspaceUrl =
  "https://admin.google.com/u/0/ac/apps/gmail/authenticateemail";
export const onboardingTourUrl = "https://youtu.be/04Cu_aygvow";
export const domainSetupKnowledgeBaseUrl =
  "https://bizcrunch.tawk.help/article/outreach-domains";

export const showOutreachFeature = true; //flag for show and hide outreach feature
export const showCampaignFeature = true; //flag for show and hide campaign feature
export const showNewPaymentFlow = true; //flag for show and hide new payment flow
export const showDealTracker = true; //flag for show and hide deal tracker
export const enableSourcePlan = true; //flag for show and hide source plan

export const calendalyInvite =
  "https://calendly.com/d/cnvf-kqb-zvy/bizcrunch-demo-buy-side";
